export const QUERY_KEY_AUTHORITIES = 'authorities';
